module.exports = __webpack_public_path__ + "static/media/klipp.ebc3720b.png";